import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useLocale } from './client';
import { withLocale } from './path';

export function useLocalizedNavigate() {
  const navigate = useNavigate();
  const locale = useLocale();

  return useCallback(
    (to: string, options?: { replace?: boolean; state?: unknown }) => {
      navigate(withLocale(to, locale), options);
    },
    [locale, navigate]
  );
}
